import React from "react";

const Row = React.forwardRef<HTMLDivElement, React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement> ,HTMLDivElement>>((props, ref) => {
  return <div
    ref={ref}
    {...props}
    className={"flex flex-row " + ( props?.className  || "")}
  />;
})

export default Row;
